window.CartDrawer = {
  init: function () {
    this.dom = {
      drawer: document.getElementById('CartDrawer'),
      drawerTitle: document.querySelector('.cart-drawer__title'),
      itemsContainer: document.getElementById('cart-drawer-items'),

      // Subtotal elements
      subtotalOriginal: document.querySelector('.wcp-original-cart-total'),
      subtotalFinal: document.querySelector('.wcp-cart-total'),

      // Checkout Button Price Span
      checkoutPrice: document.getElementById('cart-drawer-checkout-price'),

      countBubble: document.getElementById('CartDrawerCount'),
      emptyState: document.getElementById('cart-drawer-empty'),
      footer: document.getElementById('cart-drawer-footer'),
      shippingBar: document.getElementById('cart-drawer-shipping-bar'),
      upsells: document.getElementById('cart-drawer-upsells'),
      headerCount: document.querySelector('.cart_count'),
      closeBtn: document.querySelector('[data-cart-drawer-close]'),
    };

    this.lastFocusedElement = null;
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.bindEvents();

    this.fetchCart();
  },

  open: function () {
    if (!this.dom.drawer) return;
    this.dom.drawer.classList.add('is-open');
    this.dom.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    this.lastFocusedElement = document.activeElement;

    setTimeout(() => {
      if (this.dom.closeBtn) {
        this.dom.closeBtn.focus();
      } else {
        this.dom.drawer.focus();
      }
    }, 100);

    document.addEventListener('keydown', this.handleKeyDown);
  },

  close: function () {
    if (!this.dom.drawer) return;
    this.dom.drawer.classList.remove('is-open');
    this.dom.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    document.removeEventListener('keydown', this.handleKeyDown);

    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
    }
  },

  fetchCart: function () {
    if (this.dom.drawer && this.dom.drawer.classList.contains('is-open')) {
      this.dom.drawer.classList.add('is-loading');
    }

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        // --- SYNC LOGIC ---
        this.refreshCartPage();
        // ------------------

        const isWholesale =
          typeof window.isWholesaleCustomer !== 'undefined' && window.isWholesaleCustomer;

        if (isWholesale) {
          fetch('/search?view=wcp_cart')
            .then((r) => r.text())
            .then((data) => {
              try {
                const firstBrace = data.indexOf('{');
                const lastBrace = data.lastIndexOf('}');

                let wcpCartData;
                if (firstBrace !== -1 && lastBrace !== -1) {
                  const cleanData = data.substring(firstBrace, lastBrace + 1);
                  wcpCartData = JSON.parse(cleanData);
                } else {
                  wcpCartData = JSON.parse(data);
                }

                if (typeof window.wcp_data !== 'undefined') {
                  window.wcp_data.wcp_cart = wcpCartData;
                  if (wcpCartData.token && wcpCartData.token.token) {
                    window.wcp_data.wcp_cart.token = wcpCartData.token.token;
                  }
                  if (typeof window.wcpCheckCart === 'function') {
                    window.wcpCheckCart(window.wcp_data);
                  }
                }

                this.applyWCPPricing(cart, wcpCartData);
              } catch (e) {
                console.warn('Cart Drawer: Error parsing WCP Cart Data', e);
                this.applyWCPPricing(cart, { items: [] });
              }

              this.render(cart);
              if (this.dom.drawer) this.dom.drawer.classList.remove('is-loading');
            })
            .catch((e) => {
              console.warn('Cart Drawer: Error fetching WCP Cart Data', e);
              this.render(cart);
              if (this.dom.drawer) this.dom.drawer.classList.remove('is-loading');
            });
        } else {
          this.render(cart);
          if (this.dom.drawer) this.dom.drawer.classList.remove('is-loading');
        }
      })
      .catch((e) => {
        console.error('Error fetching cart:', e);
        if (this.dom.drawer) this.dom.drawer.classList.remove('is-loading');
      });
  },

  // New Helper to keep Cart Page in sync
  refreshCartPage: function () {
    const cartForm = document.getElementById('cart_form');
    if (!cartForm) return;

    fetch('/cart')
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartForm = doc.getElementById('cart_form');

        if (newCartForm) {
          // 1. Swap the HTML (The "Brittle" part)
          cartForm.innerHTML = newCartForm.innerHTML;

          // 2. The Fix: Re-initialize Theme Scripts
          // This restores functionality to the new elements

          // Re-bind Quantity Selectors (+/- buttons)
          if (window.product && typeof window.product.initializeQuantityBox === 'function') {
            window.product.initializeQuantityBox();
          }

          // Re-bind Terms & Conditions Checkbox
          // (This logic was inside an anonymous function in app.js, so we might need to rely on delegation or re-run a global init if available.
          // Fortunately, your app.js uses 'body' delegation for most things, which survives innerHTML swaps!)

          // Re-trigger WCP (Wholesale) calculations if needed
          if (typeof window.wcpRefreshCartTotal === 'function') {
            window.wcpRefreshCartTotal();
          }

          // Re-bind fancybox (for product images in cart)
          if (typeof $.fancybox !== 'undefined') {
            $('.lightbox').fancybox();
          }
        }
      })
      .catch((e) => console.error('CartDrawer: Error refreshing cart page HTML', e));
  },

  applyWCPPricing: function (cart, wcpCartData) {
    const wcpItems = wcpCartData && wcpCartData.items ? wcpCartData.items : [];
    let newTotal = 0;
    let newOriginalTotal = 0;

    cart.items.forEach((item) => {
      let priceFound = false;

      // LAYER 1: Server-Side WCP Data
      const wcpItem = wcpItems.find((wi) => wi.variant_id === item.variant_id);

      if (wcpItem) {
        // CRITICAL FIX 2: WCP Liquid often outputs the literal string "null" if there's no compare_at_price.
        // We filter out the string "null" so math operations don't evaluate to NaN.
        let comparePrice = (wcpItem.wcp_v_compare_price && wcpItem.wcp_v_compare_price !== "null") 
            ? parseInt(wcpItem.wcp_v_compare_price) 
            : null;

        item.original_price = comparePrice || wcpItem.price || item.original_price;
        item.final_price = parseInt(wcpItem.wcp_v_price);
        item.price = item.final_price;
        priceFound = true;
      }

      // LAYER 2: DOM JSON Lookup
      if (!priceFound) {
        const productJsonEl = document.querySelector(`.wcp_json_${item.product_id}`);
        if (productJsonEl) {
          try {
            const wcpJson = JSON.parse(productJsonEl.innerHTML);
            const variantData = wcpJson.variants.find((v) => v.id === item.variant_id);
            if (variantData) {
              item.final_price = variantData.price;
              item.price = variantData.price;
              item.original_price =
                variantData.compare_at_price && variantData.compare_at_price > variantData.price
                  ? variantData.compare_at_price
                  : variantData.price;
              priceFound = true;
            }
          } catch (e) {}
        }
      }

      // LAYER 3: Client-Side Fallback
      if (!priceFound) {
        this.calculateClientSidePrice(item);
      }

      // Re-calculate the line-item prices using the newly applied WCP logic
      item.final_line_price = item.final_price * item.quantity;
      item.original_line_price = item.original_price * item.quantity;
      
      newTotal += item.final_line_price;
      newOriginalTotal += item.original_line_price;
    });

    // Override cart totals with our calculated WCP totals
    cart.wcp_total_price = newTotal;
    cart.original_total_price = newOriginalTotal;
  },

  calculateClientSidePrice: function (item) {
    if (typeof window.wcp_data === 'undefined' || !window.wcp_data.wcp_customer) return;

    const customerTags = window.wcp_data.wcp_customer.tags;
    const activeDiscountsStr = window.wcp_data.active_discounts_list || '';

    if (!customerTags || !activeDiscountsStr) return;

    let maxDiscountPercent = 0;
    const discountRules = activeDiscountsStr.split(',');

    discountRules.forEach((rule) => {
      const parts = rule.split('-');
      if (parts.length < 2) return;

      const percentage = parseFloat(parts[parts.length - 1]);
      const tag = parts.slice(0, parts.length - 1).join('-');

      if (customerTags.some((ct) => ct.toLowerCase() === tag.toLowerCase())) {
        if (percentage > maxDiscountPercent) {
          maxDiscountPercent = percentage;
        }
      }
    });

    if (maxDiscountPercent > 0) {
      const discountMultiplier = (100 - maxDiscountPercent) / 100;
      let basePrice = item.original_price || item.price;
      item.final_price = Math.floor(basePrice * discountMultiplier);
      item.price = item.final_price;
    }
  },

  changeItem: function (key, qty) {
    if (this.dom.drawer) this.dom.drawer.classList.add('is-loading');
    const body = JSON.stringify({ id: key, quantity: qty });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    })
      .then((response) => response.json())
      .then((cart) => {
        this.fetchCart();
      })
      .catch((e) => {
        console.error('Error changing item:', e);
        if (this.dom.drawer) this.dom.drawer.classList.remove('is-loading');
      });
  },

  render: function (cart) {
    let displayTotal = cart.wcp_total_price !== undefined ? cart.wcp_total_price : cart.total_price;
    let originalTotal = cart.original_total_price;

    let safeItemCount = cart.item_count;
    if (typeof safeItemCount === 'undefined' && cart.items) {
      safeItemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
    }

    let cartForBar = Object.assign({}, cart);
    cartForBar.total_price = displayTotal;
    this.renderShippingBar(cartForBar);

    if (safeItemCount === 0) {
      if (this.dom.itemsContainer) this.dom.itemsContainer.innerHTML = '';
      if (this.dom.emptyState) this.dom.emptyState.classList.remove('is-hidden');
      if (this.dom.footer) this.dom.footer.classList.add('is-hidden');
      this.updateCounts(0);

      const drawerUpsells = document.getElementById('cart-drawer-upsells');
      const pageUpsells = document.getElementById('cart-page-upsells');
      if (drawerUpsells) drawerUpsells.innerHTML = '';
      if (pageUpsells) pageUpsells.innerHTML = '';
      return;
    }

    if (this.dom.emptyState) this.dom.emptyState.classList.add('is-hidden');
    if (this.dom.footer) this.dom.footer.classList.remove('is-hidden');
    this.updateCounts(safeItemCount);

    if (this.dom.checkoutPrice) {
      this.dom.checkoutPrice.textContent = this.formatMoney(displayTotal);
    }

    const totalSection = document.querySelector('.cart-drawer__total-section');
    if (this.dom.subtotalOriginal && totalSection) {
      if (displayTotal < originalTotal) {
        totalSection.classList.add('is-visible');
        this.dom.subtotalOriginal.innerHTML = this.formatMoney(originalTotal);
        this.dom.subtotalOriginal.style.textDecoration = 'line-through';
        this.dom.subtotalOriginal.style.color = '#888';
        this.dom.subtotalOriginal.style.marginRight = '10px';

        if (this.dom.subtotalFinal) {
          this.dom.subtotalFinal.innerHTML = this.formatMoney(displayTotal);
          this.dom.subtotalFinal.style.display = 'inline';
          this.dom.subtotalFinal.style.color = '#ef91b5';
          this.dom.subtotalFinal.style.fontWeight = '700';
        }
      } else {
        totalSection.classList.remove('is-visible');
      }
    }

    let html = '';
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach((item) => {
        let imgUrl = item.image ? item.image.replace(/(\.[^.]*)$/, '_300x$1') : '';
        let priceHtml = '';
        const finalLine = Number(item.final_line_price);
        const originalLine = Number(item.original_line_price);

        if (originalLine > finalLine) {
          priceHtml = `<span class="cart-drawer__item-price-original" style="text-decoration: line-through; color: #888; margin-right: 5px;">${this.formatMoney(originalLine)}</span><span class="cart-drawer__item-price-final" style="color: #ef91b5;">${this.formatMoney(finalLine)}</span>`;
        } else {
          priceHtml = `${this.formatMoney(finalLine)}`;
        }

        // --- ENHANCED VARIANT DISPLAY LOGIC ---
        let variantHtml = '';
        if (item.options_with_values && item.options_with_values.length > 0) {
          // Filter out standard "Default Title" filler
          const validOptions = item.options_with_values.filter(opt => opt.value !== 'Default Title');
          if (validOptions.length > 0) {
            // Loop through options and stack them nicely
            variantHtml = validOptions.map(opt => `<span class="cart-drawer__item-variant" style="display: block; margin-top: 4px; font-size: 0.9em; opacity: 0.8;">${opt.name}: ${opt.value}</span>`).join('');
          }
        } else if (item.variant_title && item.variant_title !== 'Default Title') {
          // Fallback if options_with_values is unavailable
          variantHtml = `<span class="cart-drawer__item-variant" style="display: block; margin-top: 4px; font-size: 0.9em; opacity: 0.8;">${item.variant_title}</span>`;
        }

        html += `
          <div class="cart-drawer__item" data-key="${item.key}">
            <div class="cart-drawer__item-image"><a href="${item.url}"><img src="${imgUrl}" alt="${item.product_title}" loading="lazy"></a></div>
            <div class="cart-drawer__item-details">
              <div class="cart-drawer__item-info">
                <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
                <div class="cart-drawer__item-price">${priceHtml}</div>
                ${variantHtml}
              </div>
              <div class="cart-drawer__item-actions">
                <div class="cart-drawer__qty-box">
                  <button type="button" class="cart-drawer__qty-btn" data-action="minus" data-key="${item.key}">−</button>
                  <input type="number" class="cart-drawer__qty-input" value="${item.quantity}" data-key="${item.key}" min="0" step="1">
                  <button type="button" class="cart-drawer__qty-btn" data-action="plus" data-key="${item.key}">+</button>
                </div>
                <a href="#" class="cart-drawer__remove" data-action="remove" data-key="${item.key}">Remove</a>
              </div>
            </div>
          </div>`;
      });
    }
    if (this.dom.itemsContainer) this.dom.itemsContainer.innerHTML = html;

    this.renderUpsells(cart);
  },

  renderShippingBar: function (cart) {
    const container = document.getElementById('cart-progress-bar-container');
    if (!container) return;
    if (cart.item_count === 0) {
      container.classList.add('is-hidden');
      return;
    } else {
      container.classList.remove('is-hidden');
    }
    let threshold = parseInt(container.dataset.threshold, 10);
    if (isNaN(threshold) || threshold <= 0) threshold = 7500;
    const preMessageTemplate = container.dataset.preMessage;
    const postMessage = container.dataset.postMessage;
    const textElement = document.getElementById('cart-drawer-shipping-text');
    const fillElement = document.getElementById('cart-drawer-progress-fill');
    const total = cart.total_price;
    const remaining = threshold - total;
    let percentage = (total / threshold) * 100;
    if (percentage > 100) percentage = 100;
    if (percentage < 0) percentage = 0;

    if (fillElement) fillElement.style.width = `${percentage}%`;

    if (total >= threshold) {
      if (textElement) textElement.innerHTML = postMessage;
      if (fillElement) fillElement.classList.add('is-success');
    } else {
      let safeRemaining = remaining;
      if (safeRemaining < 0) safeRemaining = 0;
      const remainingMoney = this.formatMoney(safeRemaining);
      const message = preMessageTemplate.replace('[amount]', `<strong>${remainingMoney}</strong>`);
      if (textElement) textElement.innerHTML = message;
      if (fillElement) fillElement.classList.remove('is-success');
    }
  },

  updateCounts: function (count) {
    const safeCount = typeof count === 'number' && !isNaN(count) ? count : 0;

    // Update Drawer Title
    if (this.dom.drawerTitle) {
      const suffix = safeCount === 1 ? 'ITEM' : 'ITEMS';
      this.dom.drawerTitle.textContent = `CART: ${safeCount} ${suffix}`;
    }

    // Update Drawer Bubble
    if (this.dom.countBubble) {
      this.dom.countBubble.textContent = safeCount;
    }

    // Update All Header Bubbles
    const headerBubbles = document.querySelectorAll('.cart_count, .cart-count');
    headerBubbles.forEach((el) => {
      el.textContent = safeCount;

      // LOGIC CHANGE: Only toggle visibility for the MOBILE badge
      // We check if the bubble is inside the '.mobile-cart-link' container
      if (el.closest('.mobile-cart-link')) {
        if (safeCount > 0) {
          el.classList.remove('is-hidden');
        } else {
          el.classList.add('is-hidden');
        }
      }
    });
  },

  formatMoney: function (cents) {
    // 1. Get the format from the body tag (set by Liquid) or fallback to default
    var format = document.body.dataset.moneyFormat || '${{amount}}';

    // 2. Convert cents to dollars/major units
    var value = (cents / 100).toFixed(2);

    // 3. Replace the placeholder {{amount}} with the actual value
    // We use a regex to catch {{amount}} or {{ amount }} with spaces
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  },

  handleKeyDown: function (e) {
    const drawer = this.dom.drawer;
    if (!drawer) return;
    if (e.key === 'Escape') {
      this.close();
      return;
    }
    if (e.key === 'Tab') {
      const focusableElementsString =
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const focusableContent = Array.from(drawer.querySelectorAll(focusableElementsString)).filter(
        (el) => el.offsetParent !== null,
      );
      if (focusableContent.length === 0) {
        e.preventDefault();
        return;
      }
      const firstFocusable = focusableContent[0];
      const lastFocusable = focusableContent[focusableContent.length - 1];
      if (!drawer.contains(document.activeElement)) {
        e.preventDefault();
        firstFocusable.focus();
        return;
      }
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  },

  bindEvents: function () {
    const closeElements = document.querySelectorAll('[data-cart-drawer-close]');
    closeElements.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.cart_button, .cart-button, a[href="/cart"]');
      if (link && !link.closest('.cart-drawer') && !link.id.includes('checkout')) {
        e.preventDefault();
        this.fetchCart();
        this.open();
      }
    });
    if (this.dom.itemsContainer) {
      this.dom.itemsContainer.addEventListener('click', (e) => {
        if (e.target.matches('[data-action="remove"]')) {
          e.preventDefault();
          const key = e.target.dataset.key;
          this.changeItem(key, 0);
        }
        const btn = e.target.closest('.cart-drawer__qty-btn');
        if (!btn) return;
        const key = btn.dataset.key;
        const qtyInput = btn.parentElement.querySelector('input');
        let currentQty = parseInt(qtyInput.value);
        const action = btn.dataset.action;
        if (action === 'plus') {
          this.changeItem(key, currentQty + 1);
        } else if (action === 'minus') {
          this.changeItem(key, currentQty - 1);
        }
      });
      this.dom.itemsContainer.addEventListener('change', (e) => {
        if (e.target.classList.contains('cart-drawer__qty-input')) {
          const key = e.target.dataset.key;
          let qty = parseInt(e.target.value);
          if (isNaN(qty) || qty < 0) qty = 1;
          this.changeItem(key, qty);
        }
      });
      this.dom.itemsContainer.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('cart-drawer__qty-input') && e.key === 'Enter') {
          e.preventDefault();
          e.target.blur();
        }
      });
    }
  },

  renderUpsells: function (cart) {
    const drawerContainer = document.getElementById('cart-drawer-upsells');
    const pageContainer = document.getElementById('cart-page-upsells');

    if (cart.item_count === 0) return;

    const productId = cart.items[0].product_id;
    const limit = 4;
    const requestUrl = `/recommendations/products?section_id=cart-upsell-recommendations&product_id=${productId}&limit=${limit}&intent=related`;

    fetch(requestUrl)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        const recommendations = html.querySelector('.cart-upsell__container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          if (drawerContainer) {
            drawerContainer.innerHTML = recommendations.outerHTML;
            this.initUpsellButtons(drawerContainer, 'drawer');
          }
          if (pageContainer) {
            pageContainer.innerHTML = recommendations.outerHTML;
            this.initUpsellButtons(pageContainer, 'page');
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  },

  initUpsellButtons: function (container, context) {
    // 1. Accordion Toggle Logic
    const toggleButtons = container.querySelectorAll('.js-upsell-toggle');
    toggleButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const variantsContainer = btn.nextElementSibling;
        const icon = btn.querySelector('.cart-upsell__toggle-icon');

        if (!variantsContainer) return; // Failsafe

        if (variantsContainer.classList.contains('is-open')) {
          variantsContainer.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          if (icon) icon.innerText = '+';
        } else {
          // Open this one
          variantsContainer.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (icon) icon.innerText = '−'; // Minus sign
        }
      });
    });

    // 2. Add To Cart Logic (for both Pills and Single-Variant buttons)
    const addButtons = container.querySelectorAll('.js-upsell-add-btn');
    addButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        // Save original text to restore later
        const originalText = btn.innerHTML;
        const isPill = btn.classList.contains('cart-upsell__variant-btn');

        // UX: Small pills get '...', wide buttons get 'Adding...'
        btn.innerText = isPill ? '...' : 'Adding...';
        btn.classList.add('is-loading');
        
        this.addItemToCart(variantId, 1, () => {
          btn.innerText = '✓';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.classList.remove('is-loading');
          }, 2000);
        }, context);
      });
    });
  },

  addItemToCart: function (variantId, quantity, callback, context) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const request = { method: 'POST', headers: headers, body: JSON.stringify({ id: variantId, quantity: quantity }) };

    fetch('/cart/add.js', request)
      .then((response) => response.json())
      .then((cart) => {
        this.fetchCart();

        if (context === 'page') {
          // If added from Cart Page, refresh page to update table
          window.location.reload();
        } else {
          // If added from Drawer (or other), just open drawer
          this.open();
        }

        if (callback) callback();
      })
      .catch((error) => {
        console.error('Error adding upsell:', error);
      });
  },
};

document.addEventListener('DOMContentLoaded', function () {
  window.CartDrawer.init();
});
